import { Component, Input } from '@angular/core';

@Component({
  selector: 'gymfinder-changelog-images',
  templateUrl: './changelog-images.component.html',
  styleUrls: ['./changelog-images.scss'],
  standalone: false,
})
export class ChangelogImagesComponent {
  @Input()
  gymImages: any;

  onImageLoadError(index: number) {
    this.gymImages.images[index].error = true;
  }
}
